export default "__VITE_ASSET__Bvy$dqGg__"